/* AlpineJS is our main JS utility framework, doc here : https://alpinejs.dev/start-here */
import Alpine from 'alpinejs';

import { gsap } from "gsap"; 
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
gsap.registerPlugin(ScrollTrigger);

import Cookies from "js-cookie";

/* Common */   
import { initAlpineJs } from './components/common/Alpine.js'  
import Sticky from "./components/common/Sticky"; 
import Slider from "./components/common/Slider"; 
import Archive from "./components/common/Archive"; 
import ArchiveMap from "./components/common/ArchiveMap"; 
import Anchors from "./components/common/Anchors"; 
import Anime from "./components/common/Anime"; 
import NewsletterForm from "./components/common/NewsletterForm"; 
 
/* Blocks */ 
import Lines from "./components/blocks/Lines";  
import Map from "./components/blocks/Map";  
import SchoolMap from "./components/blocks/SchoolMap";  

const components = {   
  sticky: {
    component: Sticky,
	}, 
	map: {
    component: Map,
	}, 
	lines: {
		component : Lines,
	},
	archive: {
		component : Archive,
	},
	archivemap: {
		component : ArchiveMap,
	},
	slider: {
		component : Slider,
	},
	anchors: {
		component : Anchors,
	},
	schoolmap:{
		component : SchoolMap
	},
	anime: {
		component : Anime,
	}
} 

 
/**
 * Init Components 
 */
const initComponents = () => {   
	/* Init components */
	for (var [key, values] of Object.entries(components)) {
		const Component = values.component;

		if (values.active != false) {
			const elms = [...document.querySelectorAll(`[data-hwc-${key}]`)];
			if (elms.length) {
				elms.forEach((el) => { 
					new Component(el);  
				});
			} else if (values.force == true) {
				 new Component(); 
			}
		}
	}  

  	ScrollTrigger.refresh();

}  
 

/**
 * Our document is ready
 */
document.addEventListener('DOMContentLoaded', () => {
  
	/* Starts Alpine */
	window.Alpine = Alpine
	Alpine.start();  
 
	/* Init anchors */
	const params = new URLSearchParams(window.location.search);
	const anchor = params.get("anchor");
	if (anchor){ 
			const target = document.querySelector(`[data-anchors-section="${anchor}"]`); 
			if( target ){ 
				setTimeout(() => {
					window.scrollTo({
						top: target.offsetTop,
						behavior: "smooth"
					});
				}, 200); 
			}
		}

	// ---------

	const newsletterFormElms = document.querySelectorAll('[data-hwc-newsletter-form]');

	if(newsletterFormElms.length){

		newsletterFormElms.forEach((formElm) => {
			new NewsletterForm(formElm);
		});

	}

	/* Init Components*/
  	initComponents();   
   
	/* Adds class to body if it's domready */
	document.body.classList.add('is-domready');

});

/**
 * Our window is fully loaded
 */
window.addEventListener('load', () => {
	
	/* Adds class to body if it's loaded  */
	document.body.classList.add('is-loaded')

});

/** 
 * Loops over all cookies set by the library and removes them.
 */
window.clearCookies = function () {
	
	if (typeof Cookies === 'undefined') return;

	Object.keys(Cookies.get()).forEach((cookieName) => {
		Cookies.remove(cookieName, { path: '/' });
	});

};

/**
 * Components instanciation
 */ 
document.addEventListener('alpine:init', () => {
	
	initAlpineJs();  

});